<template>
    <b-card>

        <validate-form ref="form">
            <b-form>
                <b-row>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="user.name" label="Navn" rules="required">
                            <!--<template #input="{ state }">
                                <b-form-input v-model="user.name" :state="state" />
                            </template>-->
                        </FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="user.email" label="E-mail" rules="required|email"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="user.password" label="Adgangskode" rules="required" :disabled="editing"></FormGroup>
                    </b-col>
                </b-row>

            </b-form>


            <b-button @click="saveUser" variant="primary" class="mx-5 my-5">
                {{ editing ? "Gem ændringer" : "Opret bruger" }}
            </b-button>

            <b-button variant="outline-secondary" type="reset" to="/users" class="mx-5 my-5">
                Annuller
            </b-button>
        </validate-form>

    </b-card>
</template>

<script>
    import Toast from '@/components/_toast.vue'

    export default {
        components: {},
        data: () => ({
            user: {
                id: null,
                name: "",
                email: "",
                password: null,
                acl: []
            }
        }),
        computed: {
            id() {
                return this.$route.params.id
            },
            editing() {
                return this.id != "create"
            }
        },
        created() {
            if (this.editing) {
                this.getUser()
            } else {
                this.$store.dispatch("app/UPDATE_PAGETITLE", "Opret bruger")
            }
        },
        mounted() { },
        methods: {
            getUser() {
                this.$http.get("/api/users/" + this.id).then(x => {
                    this.user = x.data

                    this.$store.dispatch("app/UPDATE_PAGETITLE", x.data.name)
                })
            },
            saveUser() {
                this.$refs.form.validate().then(success => {
                    if (success) {
                        this.$http.post("/api/users/save", this.user).then(x => {

                            this.$toast({
                                component: Toast,
                                props: {
                                    title: x.data.result,
                                    icon: 'CheckCircleIcon',
                                    variant: 'success',
                                },
                            })

                            if (x.data.data) {
                                this.$router.replace({ name: "user", params: { id: x.data.data } })
                            }

                            this.$store.dispatch("app/UPDATE_PAGETITLE", this.user.name)
                        })
                    }
                })
            }
        },
    }
</script>